/*
* 主入口
*/

import { useState, useEffect } from 'react';
import {
    Layout,
    Row,
    Col,
    message,
    FloatButton,
    ConfigProvider,
    theme,
} from 'antd';
import $ from 'jquery';
import cookie from 'react-cookies';
import './css/app.css';
import CNF from './incs/Config';
import {
    locale,
    AddRequestHeaders,
    DeleteCookies,
    winHeight,
} from './incs/FunHelper';

import ServiceReleaseMessage from './components/ServiceReleaseMessage';
import XHeader from './components/XHeader';

import Node from './pages/dashboards/Node';
import Seal from './pages/dashboards/Seal';
import Plms from './pages/dashboards/Plms';
import Premium from './pages/dashboards/Premium';

import AchievementSum from './pages/dashboards/AchievementSum';
import EmbraceAI from './pages/dashboards/EmbraceAI';
import XFooter from './pages/dashboards/XFooter';

const { Content, Footer } = Layout;
const { defaultAlgorithm, compactAlgorithm } = theme;

const Main = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [preGroup, setPreGroup] = useState('');
    const [navLists, setNavLists] = useState([]);
    const [btnLists, setBtnLists] = useState([]);
    const [serInfos, setSerInfos] = useState([]);
    const [serCodes, setSerCodes] = useState([]);

    const {
        token: {
            colorWhite,             // 不随主题变化的纯白色
            colorPrimary,           // 主色
            colorPrimaryBg,         // 主色浅色背景色
        },
    } = theme.useToken();

    useEffect(() => {
        $.ajax({
            url: `${CNF.sealApi}policys`,
            headers: AddRequestHeaders(),
            type: 'GET',
        }).done(function (data) {
            if (data.res === 0) {
                // 获取服务代码
                let serCodes = [];
                for (let i = 0; i < data.dat.nav_lists.length; i++) {
                    let serCode = data.dat.nav_lists[i].ptn.split('_')[1];
                    if (!serCodes.some(obj => obj === serCode)) {
                        serCodes.push(serCode);
                    }
                }
                setPreGroup(data.dat.pre_group);
                setNavLists(data.dat.nav_lists);
                setBtnLists(data.dat.btn_lists);
                setSerInfos(data.dat.ser_infos);
                setSerCodes(serCodes);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    // 若获取策略失败，直接退出登录
                    DeleteCookies();
                }, CNF.messageDuration * 1000);
            }
        }).fail(function (data) {
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
            setTimeout(function () {
                // 若获取策略失败，直接退出登录
                DeleteCookies();
            }, CNF.messageDuration * 1000);
        });
    }, [messageApi]);




    return (
        <ConfigProvider
            theme={{
                components: {
                    Table: {
                        headerBorderRadius: 0,              //  表头圆角
                        headerBg: colorPrimaryBg,           // 表头背景色
                        headerSortHoverBg: colorPrimaryBg,  // 表头排序悬浮背景色
                        headerSortActiveBg: colorPrimaryBg, // 表头排序激活背景色
                        borderColor: cookie.load(CNF.cookies.keyIsDisplayTableBorder) > 0 ? colorPrimaryBg : colorWhite, // 表格边框色
                        headerSplitColor: colorPrimaryBg,   // 表头分割线色
                    },
                    Tooltip: {
                        colorBgSpotlight: colorPrimary,
                    },
                    Select: {
                        optionActiveBg: colorPrimaryBg,
                    },
                },
            }}
        >
            {contextHolder}
            {/* 服务发布消息 */}
            {/* <ServiceReleaseMessage themeColor={props.themeColor} serInfos={serInfos} /> */}
            <Layout>
                <XHeader
                    navLists={navLists}
                    themeColor={props.themeColor}
                    setThemeColor={props.setThemeColor}
                    isCompact={props.isCompact}
                    setIsCompact={props.setIsCompact}
                    serInfos={serInfos}
                />
                <Content style={{ background: '#F7F9FA', paddingTop: 80 }}>
                    <Row>
                        <Col span={20} offset={2}>
                            <Row>
                                <Col span={24}><Node /></Col>
                                <h2>一套账户畅游整套系统，让工作变得更简单</h2>
                                <Col span={24}><Seal btnLists={btnLists} preGroup={preGroup} /></Col>
                                <h2>致力于打造项目全生命周期管理，洞悉项目的各个细节</h2>
                                <Col span={24}><Plms btnLists={btnLists} preGroup={preGroup} /></Col>
                            </Row>
                        </Col>
                    </Row>
                    <div style={{ margin: '10px 0' }}><AchievementSum /></div>
                    <Row>
                        <Col span={20} offset={2}>
                            <Row>
                                <Col span={24}><Premium /></Col>
                            </Row>

                        </Col>
                    </Row>
                </Content>
                <EmbraceAI />
                <XFooter />
            </Layout>
            <FloatButton.BackTop />
        </ConfigProvider>
    );

}

const App = (props) => {
    // 切换主体色
    const [themeColor, setThemeColor] = useState(cookie.load(CNF.cookies.keyThemeColor) ? cookie.load(CNF.cookies.keyThemeColor) : CNF.themeColors[0]);
    // 是否紧凑的
    const [isCompact, setIsCompact] = useState(false);
    return (
        <ConfigProvider
            locale={locale}
            variant='outlined'
            theme={{
                algorithm: isCompact ? compactAlgorithm : defaultAlgorithm,
                token: {
                    colorPrimary: themeColor,
                },
            }}
        >
            <Main
                m={props.m}
                nav={props.nav}
                themeColor={themeColor}
                setThemeColor={setThemeColor}
                isCompact={isCompact}
                setIsCompact={setIsCompact}
            />
        </ConfigProvider>
    )
};

export default App